/* NovaPulse V15 — display-order and default variant. No product/catalog data is mutated. */
(() => {
  'use strict';
  const norm = v => String(v ?? '').trim().toLowerCase();
  const sizeNames = /^(size|sizes|rozmiar|dimensions?|measurements?|wymiary|length|height|width)$/i;
  const number = v => {
    const m = String(v).replace(',', '.').match(/(\d+(?:\.\d+)?)/);
    return m ? Number(m[1]) : Infinity;
  };
  function dimensions(v) {
    const nums = [...String(v).replace(/,/g,'.').matchAll(/\d+(?:\.\d+)?/g)].map(x=>Number(x[0]));
    if (!nums.length) return Infinity;
    if (nums.length > 1 && /[x×*]/i.test(String(v))) return nums.slice(0,3).reduce((a,b)=>a*b,1);
    return nums[0];
  }
  function orderPicker(picker) {
    const source = picker.querySelector('script[data-np-variant-prices]');
    if (!source) return;
    let variants;
    try { variants = JSON.parse(source.textContent); } catch { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    const price = (idx, val) => {
      const found = variants.filter(v => v.available && norm(v.options?.[idx]) === norm(val));
      return found.length ? Math.min(...found.map(v => Number(v.price))) : Infinity;
    };
    const cmp = (idx, isSize) => (a,b) => {
      const av = isSize ? dimensions(a.value) : price(idx,a.value);
      const bv = isSize ? dimensions(b.value) : price(idx,b.value);
      if (Number.isFinite(av) && Number.isFinite(bv) && av !== bv) return av - bv;
      if (Number.isFinite(av) !== Number.isFinite(bv)) return Number.isFinite(av) ? -1 : 1;
      const ap = price(idx,a.value), bp = price(idx,b.value);
      if (Number.isFinite(ap) && Number.isFinite(bp) && ap !== bp) return ap - bp;
      return a.index - b.index;
    };
    picker.querySelectorAll('fieldset[data-fieldset-index]').forEach(fieldset => {
      const firstInput = fieldset.querySelector('input[data-input-id]');
      const idx = Number(firstInput?.dataset.inputId?.split('-')[0]) - 1;
      if (!Number.isInteger(idx) || idx < 0) return;
      const isSize = sizeNames.test(fieldset.querySelector('legend')?.textContent?.trim() || '');
      const labels = [...fieldset.querySelectorAll(':scope > label.variant-option__button-label')];
      labels.map((el,index)=>({el,index,value:el.querySelector('input')?.value||''}))
        .sort(cmp(idx,isSize)).forEach(({el},order)=>el.style.order=String(order));
    });
    picker.querySelectorAll('.variant-option--dropdowns').forEach(wrapper => {
      const select=wrapper.querySelector('select.variant-option__select');
      if (!select) return;
      // Use the actual Shopify option position, even with mixed button/dropdown pickers.
      const optionIndex=Number(select.options[0]?.dataset.inputId?.split('-')[0])-1;
      if (!Number.isInteger(optionIndex) || optionIndex < 0) return;
      const isSize=sizeNames.test(wrapper.querySelector('label')?.textContent?.trim() || '');
      const selected=select.value;
      [...select.options].map((el,index)=>({el,index,value:el.value}))
        .sort(cmp(optionIndex,isSize)).forEach(({el})=>select.appendChild(el));
      select.value=selected;
    });
  }
  function scan() {
    document.querySelectorAll('variant-picker[data-np-sort-variants]').forEach(orderPicker);
  }
  function chooseLowestOnce() {
    // Only on actual product pages, and never override a customer's explicit variant/deep link.
    if (document.documentElement.classList.contains('shopify-design-mode') || window.Shopify?.designMode) return;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(location.pathname)) return;
    const url=new URL(location.href);
    if (url.searchParams.has('variant') || url.searchParams.has('option_values')) return;
    const picker=document.querySelector('variant-picker[data-template-product-match="true"][data-np-sort-variants]');
    if (!picker) return;
    const source=picker.querySelector('script[data-np-variant-prices]');
    if (!source) return;
    let variants;
    try { variants=JSON.parse(source.textContent); } catch { return; }
    if (!Array.isArray(variants)) return;
    const available=variants.filter(v=>v.available && v.id && Number.isFinite(Number(v.price)));
    if (available.length<2) return;
    available.sort((a,b)=>Number(a.price)-Number(b.price));
    const initial=picker.querySelector('form.variant-picker__form > script[type="application/json"]');
    let current;
    try { current=JSON.parse(initial?.textContent||'null'); } catch { return; }
    if (!current || String(current.id)===String(available[0].id)) return;
    // Full server render keeps price, selected options, media and add-to-cart ID consistent.
    url.searchParams.set('variant',String(available[0].id));
    location.replace(url.toString());
  }
  function ready() { scan(); chooseLowestOnce(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',ready,{once:true});
  else ready();
  document.addEventListener('shopify:section:load',scan);
})();
